import React from 'react'
// @ts-ignore no types
import { InfoPill } from '../../../../elementals'
import { OnlineAuctionSegmentBidRank } from '@adc/sdk/types'
import { ColorNames } from '../../../../../constants'
import { formatMoney } from '../../../../../utils/formatters'
import { acceptedOffer } from '../utils'

interface BidRankDistancePillProps {
  bidRank: OnlineAuctionSegmentBidRank
  isBuyer?: boolean
  isMobile?: boolean
  compact?: boolean
}

const BidRankDistancePill = ({
  isBuyer,
  bidRank,
  isMobile,
  compact = false,
}: BidRankDistancePillProps) => {
  const overTakeDelta = isBuyer
    ? bidRank?.overtake_delta
    : bidRank?.net_offer_equal_delta

  if (bidRank?.rank === 1 || !overTakeDelta || acceptedOffer(bidRank))
    return null

  return (
    <InfoPill
      size='medium'
      backgroundColor={ColorNames.CautionLight}
      foregroundColor={ColorNames.Caution}
      includeBorder
      iconName={overTakeDelta >= 1 ? 'arrow-down' : undefined}
      extraPadding={isMobile ? 'small' : 'medium'}
      content={`
            ${overTakeDelta >= 1 ? formatMoney(overTakeDelta) : '< $1'}${
        !compact ? ' From 1st Place' : ''
      }`}
    />
  )
}

export default BidRankDistancePill
